<div class="contador" [class.contador--compacto]="compact">
  <button type="button" class="contador-btn" (click)="alterar(-1)" [attr.aria-label]="rotuloDiminuir" [disabled]="!podeDiminuir">
    <mat-icon class="material-symbols-outlined">remove</mat-icon>
  </button>
  @if (readonly) {
  <div class="contador-valor">{{ (value ?? 0) | number: formatoLeitura }}</div>
  } @else {
  <input class="contador-valor contador-input" [currencyMask]="mascara" [attr.aria-label]="ariaLabel"
    [ngModel]="value ?? 0" (ngModelChange)="digitar($event)" [disabled]="disabled"
    (focus)="$any($event.target).select()">
  }
  <button type="button" class="contador-btn" (click)="alterar(1)" [attr.aria-label]="rotuloAumentar" [disabled]="readonly || disabled">
    <mat-icon class="material-symbols-outlined">add</mat-icon>
  </button>
</div>
